export const filterDecimal = (value) => {
  if (Math.round(value) !== value) {
    return value.toFixed(2);
  }

  return value % 1 === 0 ? value : value.toFixed(2);
};
